import React from 'react';
import { BounceLoader } from "react-spinners";
import { translate } from "../lang/trans";

const Loading = () => (
   <div className="loading-container">
      <div className="loading-title">{translate('завантаження карти')}...</div>
      <BounceLoader
         size={50}
         color={"#02B9B5"}
         loading
      />
   </div>
);

export default Loading;
